import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

import generateColors from "../assets/colors";

import PtrIcon from "@/components/shared/PtrIcon";

Vue.use(Vuetify);

const customColors = generateColors();

customColors["background-darken5"] = customColors.background.darken5;
customColors["background-darken3"] = customColors.background.darken3;
customColors["background-lighten2"] = customColors.background.lighten2;
customColors["background-lighten3"] = customColors.background.lighten3;
customColors["background-lighten4"] = customColors.background.lighten4;
customColors["background-lighten5"] = customColors.background.lighten5;
customColors["foreground-lighten1"] = customColors.foreground.lighten1;
customColors["foreground-lighten2"] = customColors.foreground.lighten2;
customColors["foreground-lighten3"] = customColors.foreground.lighten3;
customColors["foreground-lighten4"] = customColors.foreground.lighten4;
customColors["foreground-lighten5"] = customColors.foreground.lighten5;
customColors["foreground-darken1"] = customColors.foreground.darken1;
customColors["foreground-darken2"] = customColors.foreground.darken2;
customColors["foreground-darken3"] = customColors.foreground.darken3;
customColors["foreground-darken4"] = customColors.foreground.darken4;
customColors["foreground-darken5"] = customColors.foreground.darken5;
customColors["theme-lighten5"] = customColors.theme.lighten5;
customColors["theme-lighten4"] = customColors.theme.lighten4;
customColors["theme-lighten3"] = customColors.theme.lighten3;
customColors["theme-lighten2"] = customColors.theme.lighten2;
customColors["theme-lighten1"] = customColors.theme.lighten1;
customColors["theme-darken1"] = customColors.theme.darken1;
customColors["theme-darken2"] = customColors.theme.darken2;
customColors["theme-darken3"] = customColors.theme.darken3;
customColors["theme-darken4"] = customColors.theme.darken4;
customColors["theme-darken5"] = customColors.theme.darken5;
customColors["danger-darken1"] = customColors.danger.darken1;
customColors["danger-lighten3"] = customColors.danger.lighten3;
customColors["danger-lighten4"] = customColors.danger.lighten4;
customColors["danger-lighten5"] = customColors.danger.lighten5;
customColors["alert-darken1"] = customColors.alert.darken1;
customColors["alert-darken2"] = customColors.alert.darken2;
customColors["alert-darken5"] = customColors.alert.darken5;
customColors["alert-lighten5"] = customColors.alert.lighten5;
customColors["alert-lighten4"] = customColors.alert.lighten4;
customColors["success-darken2"] = customColors.success.darken2;
customColors["info-lighten5"] = customColors.info.lighten5;
customColors["info-lighten4"] = customColors.info.lighten4;
customColors["info-darken2"] = customColors.info.darken2;

const vuetify = new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: customColors
    }
  },
  icons: {
    values: {
      dataTableSort: {
        component: PtrIcon, // you can use string here if component is registered globally
        props: {
          // pass props to your component if needed
          icon: ["arrows-down"]
        }
      }
    }
  }
});

export default vuetify;
